import React, {useState} from 'react'
import Container from '../components/Container'
import { Link } from 'react-router-dom'
import Button from '../components/Button'
import UploadModal from '../components/modal/UploadModal'
// import Uploaded from '../components/uploads/Uploaded'
// import Saved from '../components/uploads/Saved'




const CvReview = () => {

    const [isUploadModalOpen, setUploadModalOpen] = useState(false)
    const toggleUploadModal = () => {
      setUploadModalOpen(!isUploadModalOpen)
    }
  return (
    <Container>
        <UploadModal 
      isOpen = {isUploadModalOpen} 
      onClose={toggleUploadModal} 
    />
        <div className='grid  h-[inherit] w-[inherit] font-poppins'>
            <div>
            <div className='w-[100%] bg-main-blue h-[22%]  mt-2 rounded-2xl grid grid-cols-[80%_20%]'>
                    <div className='flex flex-col justify-center pl-10 text-white'>
                        <h1 className='mb-3 flex text-2xl '>
                            Certificate and CV Review    
                        </h1>
                        <div className='flex gap-24'>
                        <Link to = "/uploaded" className='pt-10 text-sm font-normal'>Upload Documents</Link>
                        <Link to = "/saved" className='pt-10 text-sm font-normal' >Saved Documents</Link>
                    </div>
                    </div>
                    </div>
                    <div className='flex flex-col  justify-center items-center mt-[10rem]'>
                    <Button onClick={toggleUploadModal}>
                        Upload file from device
                    </Button>
                    <p className='mt-[1rem] text-red-700 italic '>File size should be less than 3mb</p>
                    <p className='mt-[5rem]  '>or</p>
                    <p className='mt-[1rem]  '>Import text from <a href = "/" className='text-indigo-700'>LinkedIn</a> </p>
                    </div>
            </div>
        </div>
    </Container>
  )
}

export default CvReview